'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var mustache = require('mustache');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var DetailsCard = require('./DetailsCard/DetailsCard.js');
var Currency = require('./Currency.js');
var index = require('./Icon/index.js');
var useIsMobile = require('../providers/useIsMobile.js');
var PackageName = require('./PackageName.js');
var SessionContext = require('../providers/SessionContext.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var mustache__default = /*#__PURE__*/_interopDefaultLegacy(mustache);

const PackageCardClaims = _ref => {
  let {
    packageDetails,
    currency,
    claimDetails,
    layout,
    additionalDetails
  } = _ref;
  const isMobile = useIsMobile["default"]();
  const {
    claimsShipmentItemsCount,
    claimsReasonLabel,
    claimsReasonPackageMissing
  } = nthHookTranslations.useTranslations();
  const {
    localeCountry,
    localeLanguage
  } = SessionContext.useSession();
  return /*#__PURE__*/React__default["default"].createElement(DetailsCard.DetailsCardContainer, {
    layout: layout
  }, /*#__PURE__*/React__default["default"].createElement(DetailsCard.DetailsCardLeftColumn, null, /*#__PURE__*/React__default["default"].createElement(index["default"], {
    icon: "Package",
    width: isMobile ? '69px' : '122px',
    height: isMobile ? '73px' : '128px'
  })), /*#__PURE__*/React__default["default"].createElement(DetailsCard.DetailsCardRightColumn, null, /*#__PURE__*/React__default["default"].createElement(DetailsCard.DetailsCardHeader, null, /*#__PURE__*/React__default["default"].createElement(PackageName["default"], {
    edd: packageDetails.edd,
    status: packageDetails.status,
    statusCode: packageDetails.statusCode
  })), /*#__PURE__*/React__default["default"].createElement(DetailsCard.DetailsCardAttributesContainer, null, /*#__PURE__*/React__default["default"].createElement(DetailsCard.DetailsCardAttribute, null, mustache__default["default"].render(claimsShipmentItemsCount ?? '', {
    count: packageDetails.items.length
  })), /*#__PURE__*/React__default["default"].createElement(DetailsCard.DetailsCardAttribute, null, /*#__PURE__*/React__default["default"].createElement(Currency.Currency, {
    value: packageDetails.totalPrice,
    currency: currency,
    locale: `${localeLanguage ?? ''}_${localeCountry ?? ''}`
  }))), (claimDetails === null || claimDetails === void 0 ? void 0 : claimDetails.claimType) && /*#__PURE__*/React__default["default"].createElement(DetailsCard.DetailsCardStrongText, null, mustache__default["default"].render(claimsReasonLabel ?? '', {
    reason: claimsReasonPackageMissing
  })), additionalDetails));
};
var PackageCardClaims$1 = nthHookTranslations.withTranslationsProvider(PackageCardClaims, {
  translationKeys: ['claimsShipmentItemsCount', 'claimsReasonLabel', 'claimsReasonPackageMissing']
});

exports["default"] = PackageCardClaims$1;
